$ = require 'jquery'
b = require 'lib/browser-detect'

module.exports = new class

  constructor: ->
    @browserStr = b.browser.toLowerCase()
    # Safari returns versions like 10.1
    @browserVersionStr = "#{b.browser}-#{b.version}".toLowerCase().replace(/\.\d+$/, '')
    @osStr = b.OS.toLowerCase()
    @asString = "#{@browserStr} #{@browserVersionStr} #{@osStr}"
    $ => $('body').addClass(@asString)

  isTouch: ->
    @isAndroid() || @isIos()

  isAndroid: ->
    @osStr == 'android'

  isIos: ->
    @osStr in ['ipad', 'iphone']

  isHighDPI: -> window.devicePixelRatio > 1

  isEmbeddedDocument: ->
    window.top != window.self

  allowsDynamicFavicon: ->
    @browserStr in ['chrome', 'firefox']

  respectsCrossDomainDownloadAttribute: ->
    # Although FF supports the download attribute,
    # it only respects it for same-origin resources.
    # https://bugzilla.mozilla.org/show_bug.cgi?id=874009
    @browserStr in ['chrome', 'opera']

  detectCustomWebkitScrollbars: ->
    try
      $('::-webkit-scrollbar')
      className = 'body-webkit-scrollbars'
    catch
      className = 'body-no-webkit-scrollbars'
    finally
      $('body').addClass className



// WEBPACK FOOTER //
// ./app/scripts/lib/browser.coffee